import { useState } from "react"
import { useLocation, useNavigate } from "react-router"

export const useServerFilters = <T extends Record<string, unknown>>(
  initialFilters: T,
) => {
  const location = useLocation()
  const navigate = useNavigate()

  const [serverFilters, setServerFilters] = useState<T>(
    location.state?.serverFilters || initialFilters,
  )

  const onServerFiltersChange = (newFilters: T) => {
    setServerFilters(newFilters)
    navigate(".", {
      state: { ...location.state, serverFilters: newFilters },
      replace: true,
    })
  }

  const resetFilters = () => {
    onServerFiltersChange(initialFilters)
  }

  return {
    serverFilters,
    onServerFiltersChange,
    onResetServerFilters: resetFilters,
  }
}
